// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Ordering from "@rescript/runtime/lib/es6/Stdlib_Ordering.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let PromotionStatus__StatusFromRawValueNotFound = /* @__PURE__ */Primitive_exceptions.create("PromotionStatus.PromotionStatus__StatusFromRawValueNotFound");

function toRawValue(status) {
  if (status === "STOPPED") {
    return "STOPPED";
  } else if (status === "ARCHIVED") {
    return "ARCHIVED";
  } else if (status === "DRAFT") {
    return "DRAFT";
  } else if (status === "NOT_PROGRAMMED") {
    return "NOT_PROGRAMMED";
  } else if (status === "ONGOING") {
    return "ONGOING";
  } else if (status === "EXPIRED") {
    return "EXPIRED";
  } else {
    return "PROGRAMMED";
  }
}

function fromRawValue(status) {
  switch (status) {
    case "ARCHIVED" :
      return "ARCHIVED";
    case "DRAFT" :
      return "DRAFT";
    case "EXPIRED" :
      return "EXPIRED";
    case "NOT_PROGRAMMED" :
      return "NOT_PROGRAMMED";
    case "ONGOING" :
      return "ONGOING";
    case "PROGRAMMED" :
      return "PROGRAMMED";
    case "STOPPED" :
      return "STOPPED";
    default:
      throw {
        RE_EXN_ID: PromotionStatus__StatusFromRawValueNotFound,
        Error: new Error()
      };
  }
}

function toString(status) {
  if (status === "STOPPED") {
    return I18n.t("Stopped");
  } else if (status === "ARCHIVED") {
    return I18n.t("Archived");
  } else if (status === "DRAFT") {
    return I18n.t("Draft");
  } else if (status === "NOT_PROGRAMMED") {
    return I18n.t("Unscheduled");
  } else if (status === "ONGOING") {
    return I18n.t("Ongoing");
  } else if (status === "EXPIRED") {
    return I18n.t("Expired");
  } else {
    return I18n.t("Scheduled");
  }
}

let statusesWeight = [
  [
    "DRAFT",
    0
  ],
  [
    "ONGOING",
    1
  ],
  [
    "PROGRAMMED",
    2
  ],
  [
    "STOPPED",
    3
  ],
  [
    "NOT_PROGRAMMED",
    4
  ],
  [
    "EXPIRED",
    5
  ],
  [
    "ARCHIVED",
    6
  ]
];

function globalFromStatuses(statuses) {
  return statuses.toSorted((current, next) => {
      let match = statusesWeight.find(param => param[0] === current);
      let match$1 = statusesWeight.find(param => param[0] === next);
      if (match !== undefined) {
        if (match$1 !== undefined) {
          return Stdlib_Ordering.fromInt(match[1] - match$1[1] | 0);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    })[0];
}

export {
  PromotionStatus__StatusFromRawValueNotFound,
  toRawValue,
  fromRawValue,
  toString,
  statusesWeight,
  globalFromStatuses,
}
/* I18n Not a pure module */
